import React, {useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {
    Box,
    Container,
    Avatar,
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TableFooter,
    TablePagination,
    TextField,
    Divider
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserListSkelet from '../../skeletons/UserListSkelet';
import {get, useDelete, useGet} from '../../API/request';
import {useConfirm} from "../../components/confirm";
import {BallTriangle} from "react-loader-spinner";
import '../../styles/All.css'
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

const UserHistory = () => {

    const {id} = useParams();
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = useState(true);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [data, setData] = useState();

    const [filterId, setFilterId] = useState('');
    const [filterName, setFilterName] = useState('');
    const [filterPlatformId, setFilterPlatformId] = useState('');
    const [curSearchVal, setCurSearchVal] = useState('admin/users/history');

    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [count, setCount] = useState(0);

    const loadTariffs = () => {
        setIsDataLoading(true);
        setIsLoaded(true)

        let endpoint = `${curSearchVal}?user_id=${id}&page=${page + 1}&limit=${limit}`;

        get(endpoint)
            .then((resp) => {
                if (resp.status === 'success') {
                    setData(resp.data.history)
                    setCount(resp.data.allCount)
                }

            })
            .catch((err) => {
                setData([])
                setCount(0)
            })
            .finally(() =>{
                setIsDataLoading(false);
                setIsDataLoaded(false);
                setIsLoaded(false)
            });
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeLimit = (event) => {
        setLimit(event.target.value);
        setPage(0);
    };

    const searchInputChange = (newVal) => {
        setCurSearchVal(newVal);

        setFilterName('');
        setFilterId('');
        setFilterPlatformId('');

        if (filterName !== '' || filterId !== '' || filterPlatformId !== '') {
            loadTariffs(false);
        }
    };

    useEffect(() => {
        loadTariffs();
    }, [curSearchVal, page, limit]);

    if (isLoaded) {
        return (
            <div className="loader">
                <BallTriangle
                    height="100"
                    width="100"
                    color='grey'
                    ariaLabel='loading'
                />
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>Users</title>
            </Helmet>
            <Box className="headerWrapper" sx={{pb: 2}}>
                <Box className="headerTitle">
                    <Button startIcon={<ChevronLeft/>} onClick={() => navigate(-1)}>
                        Назад
                    </Button>
                    Пользователи
                </Box>
                <ul className="headerList">
                    <li onClick={() => navigate("/app/users")}>Пользователи</li>
                    <li>/</li>
                    <li onClick={() => navigate(`/app/user/${id}`)}>Информация</li>
                    <li>/</li>
                    <li>Истории</li>
                </ul>
            </Box>
            <Box sx={{backgroundColor: 'background.default', minHeight: '100%', py: 3}}>
                <Container maxWidth={false}>
                    {
                        isDataLoading ?
                            <UserListSkelet/>
                            :
                            <>
                                <Box sx={{pt: 3}}>
                                    <Card>
                                        <PerfectScrollbar>
                                            <Box sx={{pt: 1, pb: 2, px: 2}}>
                                                <Box>
                                                    <FormControl fullWidth sx={{mt: 2, mb: 1}}>
                                                        <InputLabel id="searchType">
                                                            Выберите тип истории
                                                        </InputLabel>
                                                        <Select
                                                            labelId="searchType"
                                                            name="searchValue"
                                                            value={curSearchVal}
                                                            label="Выберите тип истории"
                                                            onChange={(evt) => searchInputChange(evt.target.value)}
                                                        >
                                                            <MenuItem value="admin/users/history">История изменений</MenuItem>
                                                            <MenuItem value="admin/finance/history">История пополнений</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            </Box>
                                            <Box sx={{minWidth: 1000}}>
                                                <Divider/>
                                                { curSearchVal === "admin/users/history"
                                                    ? <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{width: 80}}>
                                                                    Id
                                                                </TableCell>
                                                                <TableCell>
                                                                    User Id
                                                                </TableCell>
                                                                <TableCell>
                                                                    Тип обновления
                                                                </TableCell>
                                                                <TableCell>
                                                                    Значение
                                                                </TableCell>
                                                                <TableCell>
                                                                    Сообщение
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {data?.map((item) => (
                                                                <TableRow hover key={item.id}>
                                                                    <TableCell sx={{width: 80}}>
                                                                        {item?.id}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.user_id || '---'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.type_update || '---'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.value || '---'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.text || '---'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                        <TableFooter>
                                                            <TableRow>
                                                                <TablePagination
                                                                    labelRowsPerPage={
                                                                        <span>Кол-во строк на странице:</span>}
                                                                    rowsPerPageOptions={[10, 20, 30, 40, 50]}
                                                                    colSpan={7}
                                                                    count={count}
                                                                    rowsPerPage={limit}
                                                                    page={page}
                                                                    onPageChange={handleChangePage}
                                                                    onRowsPerPageChange={handleChangeLimit}
                                                                />
                                                            </TableRow>
                                                        </TableFooter>
                                                    </Table>
                                                    : <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{width: 80}}>
                                                                    Id
                                                                </TableCell>
                                                                <TableCell>
                                                                    Coin Id
                                                                </TableCell>
                                                                <TableCell>
                                                                    Type transaction Id
                                                                </TableCell>
                                                                <TableCell>
                                                                    Cумма
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {data?.map((item) => (
                                                                <TableRow hover key={item.id}>
                                                                    <TableCell sx={{width: 80}}>
                                                                        {item?.id}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.coin_id || '---'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.type_transaction_id || '---'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.amount || '---'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                        <TableFooter>
                                                            <TableRow>
                                                                <TablePagination
                                                                    labelRowsPerPage={
                                                                        <span>Кол-во строк на странице:</span>}
                                                                    rowsPerPageOptions={[10, 20, 30, 40, 50]}
                                                                    colSpan={7}
                                                                    count={count}
                                                                    rowsPerPage={limit}
                                                                    page={page}
                                                                    onPageChange={handleChangePage}
                                                                    onRowsPerPageChange={handleChangeLimit}
                                                                />
                                                            </TableRow>
                                                        </TableFooter>
                                                    </Table>
                                                }
                                            </Box>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </>
                    }
                </Container>
            </Box>
        </>
    );
};

export default UserHistory;
